<!--
 * @Description: 睡眠时间
 * @Author: Zhang Xin (1483812724@qq.com)
 * @Date: 2023-08-23 10:10:44
 * @LastEditors: Wang Xiaowu (wangxiaowu@example.com)
 * @LastEditTime: 2023-11-14 15:38:01
 -->
<template>
  <div class="sleepTime">
    <div class="eacharts">
      <echarts :chart-id="'sleepTime'" :chart-option="options"></echarts>
    </div>
    <div class="times">
      <div>
        <div>{{starty}}</div>
        <div>{{startt}}</div>
      </div>
      <div>
        <div>{{startt1 == '20:00' ? starty : startt1 == '07:00' ? starty1 : ''}}</div>
        <div>{{startt1 == '20:00' ? '12:00' : startt1 == '07:00' ? '00:00' : ''}}</div>
      </div>
      <div>
        <div>{{starty1}}</div>
        <div>{{startt1}}</div>
      </div>
    </div>
    <div class="type">
      <span>
        <i style="background-color: #F9C570;"></i> 清醒
        
      </span>
      <span>
        <i style="background-color: #B1DE58;"></i> 浅睡
        
      </span>
      <span>
        <i style="background-color: #51AFF2;"></i> 中睡
      </span>
      <span>
        <i style="background-color: #514DF1;"></i> 深睡
      </span>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    sleepData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      ss: "",
      ff: "",
      starty: '',
      startt: '',
      starty1: '',
      startt1: '',
      options: {
        // tooltip: {
        //   trigger: "axis",
        //   axisPointer: {
        //     type: "line"
        //   },
        //   formatter: function (x) {
        //     let shenshui = x[0].data + '次'
        //     let zhongshui = x[0].axisValue
        //     let ss = '<div>' + shenshui + '</div>'
        //     let zs = '<div>' + zhongshui + '</div>'
        //     let ddv =zs + ss
        //     return ddv
        //   },
        // },
        xAxis: {
          type: "category",
          show: false,
          axisLine: { show: false }, //不显示坐标轴
          axisTick: {
            show: false, //不显示坐标轴刻度线
          },
          data: (function () {
            let list = [];
            for (let i = 1; i <= 80; i++) {
              list.push(0);
            }
            return list;
          })(),
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            name: "Placeholder",
            type: "bar",
            stack: "Total",
            silent: true,
            barWidth: 5,
            barGap: "0%",
            barCategoryGap: "0%",
            itemStyle: {
              borderColor: "transparent",
              color: "transparent",
            },
            emphasis: {
              itemStyle: {
                borderColor: "transparent",
                color: "transparent",
              },
            },
            data: [],
          },
          {
            name: "深睡",
            type: "bar",
            stack: "Total",
            label: {
              show: false,
              position: "top",
            },
            itemStyle: {
              color: "#514DF1",
            },
            data: [],
          },
          {
            name: "中睡",
            type: "bar",
            stack: "Total",
            label: {
              show: false,
              position: "bottom",
            },
            itemStyle: {
              color: "#51AFF2",
            },
            data: [],
          },
          {
            name: "浅睡",
            type: "bar",
            stack: "Total",
            label: {
              show: false,
              position: "bottom",
            },
            itemStyle: {
              color: "#B1DE58",
            },
            data: [],
          },
          {
            name: "清醒",
            type: "bar",
            stack: "Total",
            label: {
              show: false,
              position: "bottom",
            },
            itemStyle: {
              color: "#F9C570",
            },
            data: [],
          },
        ],
      },
    };
  },
  created() {
    let ss = this.sleepData.sleepTime
      ? this.sleepData.sleepTime.slice(0, 2)
      : "00";
    let ff = this.sleepData.sleepTime
      ? this.sleepData.sleepTime.slice(3, 5)
      : "00";
    this.ss = ss;
    this.ff = ff;
    let stY = this.sleepData.startDate
    let stT = this.sleepData.startTime
    let enY = this.sleepData.endDate
    let enT = this.sleepData.endTime
    this.starty = stY
    this.startt = stT
    this.starty1 = enY
    this.startt1 = enT
    let options = { ...this.options };
    options.series[1].data = [];
    options.series[2].data = [];
    options.series[3].data = [];
    options.series[4].data = [];
    options.series[0].data = [];
    this.sleepData.list.forEach((item) => {
      if (item.sleepStatus == 0) {
        options.series[0].data.push(200);
      } else if (item.sleepStatus == 1) {
        options.series[0].data.push(400);
      } else if (item.sleepStatus == 2) {
        options.series[0].data.push(600);
      } else {
        options.series[0].data.push(800);
      }
    });
    options.series[0].data.forEach((items) => {
      if (items == 800) {
        options.series[1].data.push(200);
      } else {
        options.series[1].data.push(0);
      }
      if (items == 600) {
        options.series[2].data.push(200);
      } else {
        options.series[2].data.push(0);
      }
      if (items == 400) {
        options.series[3].data.push(200);
      } else {
        options.series[3].data.push(0);
      }
      if (items == 200) {
        options.series[4].data.push(200);
      } else {
        options.series[4].data.push(0);
      }
    });
    this.options = { ...options };
  },
  watch: {
    sleepData: {
      handler(newData, oldData) {
        if (newData) {
          this.sleepData = newData;
          let ss = this.sleepData.sleepTime
            ? this.sleepData.sleepTime.slice(0, 2)
            : "00";
          let ff = this.sleepData.sleepTime
            ? this.sleepData.sleepTime.slice(3, 5)
            : "00";
          this.ss = ss;
          this.ff = ff;
          let stY = this.sleepData.startDate
          let stT = this.sleepData.startTime
          let enY = this.sleepData.endDate
          let enT = this.sleepData.endTime
          this.starty = stY
          this.startt = stT
          this.starty1 = enY
          this.startt1 = enT
          let options = { ...this.options };
          options.series[1].data = [];
          options.series[2].data = [];
          options.series[3].data = [];
          options.series[4].data = [];
          options.series[0].data = [];
          this.sleepData.list.forEach((item) => {
            if (item.sleepStatus == 0) {
              options.series[0].data.push(200);
            } else if (item.sleepStatus == 1) {
              options.series[0].data.push(400);
            } else if (item.sleepStatus == 2) {
              options.series[0].data.push(600);
            } else {
              options.series[0].data.push(800);
            }
          });
          options.series[0].data.forEach((items) => {
            if (items == 800) {
              options.series[1].data.push(200);
            } else {
              options.series[1].data.push(0);
            }
            if (items == 600) {
              options.series[2].data.push(200);
            } else {
              options.series[2].data.push(0);
            }
            if (items == 400) {
              options.series[3].data.push(200);
            } else {
              options.series[3].data.push(0);
            }
            if (items == 200) {
              options.series[4].data.push(200);
            } else {
              options.series[4].data.push(0);
            }
          });
          this.options = { ...options };
        } else {
          this.sleepData = oldData;
          // console.log(888888, this.sleepData)
        }
      },
      deep: true,
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.sleepTime {
  width: 100%;
  margin-top: 20px;
  position: relative;
  .time {
    width: 350px;
    text-align: center;
    margin: 0 auto;
    color: #333;
    font-size: 36px;
    font-weight: bold;
    > span {
      font-size: 72px;
    }
  }
  .eacharts {
    width: 100%;
    height: 250px;
    position: relative;
  }
  .times {
    width: 100%;
    position: absolute;
    bottom: 50px;
    left: 0;
    display: flex;
    padding: 0 60px;
    box-sizing: border-box;
    justify-content: space-between;
    >div {
      text-align: center;
    }
  }
  .type {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    >span {
      display: block;
      margin-left: 30px;
      i {
        display: inline-block;
        width: 15px;
        height: 6px;
        border-radius: 30px;
        vertical-align: 2px;
      }
    }
  }
}
</style>